import { getCloneWarningMessage } from 'asset-actions-lib-forms/utils/formCloningUtils';
import FormCloningWarningMessage from 'asset-actions-lib-forms/clone/components/FormCloningWarningMessage';

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/components/formCloning/FormCloningWarning.js
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormCloningWarning({
  isDifferentBusinessUnit = false,
  formHasWorkflows,
  isExternalEditor,
  isBusinessUnitEnabled
}) {
  const cloneWarningMessage = getCloneWarningMessage({
    isBusinessUnitEnabled,
    formHasWorkflows,
    isDifferentBusinessUnit
  });
  return /*#__PURE__*/_jsx(FormCloningWarningMessage, {
    warning: cloneWarningMessage,
    isExternalEditor: isExternalEditor
  });
}